import { h } from "hyperapp";
import listCSS from "../../sections/unvisited-places/list.css";

export const columnSelector = ({
  actions,
  disabled,
  section,
  state,
  translations,
}) => {
  const { toggleColumnState } = actions;

  const { columns } = state[section];

  const orderedColumns = columns.sort((a, b) => a.text.localeCompare(b.text));

  return (
    <div
      class="dropdown col-12 col-md-auto p-0"
      key={section}
      onloaded={() => actions.loadColumns({ section })}
    >
      <button
        aria-expanded="false"
        aria-haspopup="true"
        class="btn btn-block"
        data-toggle="dropdown"
        disabled={disabled}
        id="columnSelector"
        type="button"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="13"
          viewBox="0 0 14 13"
          fill="none"
        >
          <path
            d="M12.4166 0.5H1.58331C0.892948 0.5 0.333313 1.07563 0.333313 1.78571V11.2143C0.333313 11.9244 0.892948 12.5 1.58331 12.5H12.4166C13.107 12.5 13.6666 11.9244 13.6666 11.2143V1.78571C13.6666 1.07563 13.107 0.5 12.4166 0.5ZM6.16665 10.7857H1.99998V3.92857H6.16665V10.7857ZM12 10.7857H7.83331V3.92857H12V10.7857Z"
            fill="#9DACB7"
          />
        </svg>
      </button>
      <div aria-labelledby="columnSelector" class="dropdown-menu">
        {orderedColumns.map(({ fixed, id, selected, text }) => (
          <button
            class="dropdown-item"
            disabled={fixed}
            onclick={() => toggleColumnState({ id, section })}
            type="button"
          >
            <span style="display: flex;  align-items:center">
              {selected ? (
                <input
                  type="checkbox"
                  name=""
                  style="accent-color:#2D6B94 !important"
                  class="custom_checkbox"
                  checked
                />
              ) : (
                <input type="checkbox" />
              )}
              <span style="padding-left: 5px;">{text}</span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};
